// @flow
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import CustomButton from '../CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomModal from '../CustomModal/CustomModal';
import {colors} from '../../assets/styles/colors';
// import megaphone from '../../assets/img/002-megaphone 1.svg';
import testStore from '../../assets/img/testStore.svg';

import type {User, Store} from '../../entities';
import type {RootState} from '../../modules';
import type {Dispatch} from 'redux';
import {bindActionCreators} from 'redux';
import {getCustomDomain} from '../../utils/component';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({}, dispatch)
)(TestOrdersModal);

type Props = {
  open: boolean,
  handleClose: () => void,
  user?: User,
  store?: Store,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 415,
    padding: theme.spacing(4, 1, 2, 1),
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '24px',
    marginTop: theme.spacing(2),
  },
  subtitle: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '20px',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: '24px',
    },
  },
  description: {
    textAlign: 'center',
    fontSize: '0.875rem',
    color: colors.grey800,
  },
  innerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  button: {
    width: '75%',
    height: 40,
    marginTop: theme.spacing(2),
    fontSize: '1rem',
    fontWeight: 600,
    padding: '6px 50px',
  },
  imgStar: {
    width: '4rem',
  },
  textTest: {
    margin: theme.spacing(2, 0),
    textAlign: 'center',
    color: ' #55556D',
    fontSize: '16px',
    '& span': {
      fontWeight: 700,
    },
  },
  containerBtns: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    width: '100%',
  },
  containerImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: '50%',
    backgroundColor: '#F8F5FE',
    width: '8rem',
    height: '8rem',
    '& img': {
      width: '3.25rem',
    },
  },
}));

function TestOrdersModal(props: Props) {
  const {open, handleClose, user, store} = props;
  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <div className={classes.containerImage}>
          <img src={testStore} alt="test your store" />
        </div>
        <div className={classes.innerContent}>
          <Typography className={classes.title}>
            {user ? user.firstName : ''}
          </Typography>
          <Typography className={classes.subtitle}>
            ¡Todavía no has generado tu
            <br /> venta de pruebas!
          </Typography>
        </div>

        <Typography className={classes.textTest}>
          Primero queremos que <span>tú</span> experimentes{' '}
          <span>lo fácil</span> que es comprar en{' '}
          <span>tu nueva tienda virtual</span> y estés convencido que estás
          yendo por el camino adecuado.
        </Typography>

        <div className={classes.containerBtns}>
          <CustomButton
            variant="contained"
            className={classes.button}
            target="_blank"
            rel="noopener noreferrer"
            href={store ? `https://${getCustomDomain(store)}?first_sale=1` : ''}
          >
            Ir a ver mi tienda
          </CustomButton>
          <CustomButton onClick={handleClose}>Cerrar</CustomButton>
        </div>
      </div>
    </CustomModal>
  );
}

TestOrdersModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  user: PropTypes.object,
  store: PropTypes.object,
};
